// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//* Variable Declaration
const region = 'us-gov-west-1';
const apiUrl = 'https://9el04e6sd7.execute-api.us-gov-west-1.amazonaws.com/dev';
const state = 'az';
const city = 'centurion';
const agencytype = 'court';
const envName = 'dev';

export const environment = {
  production: false,
  apiUrl: apiUrl,
  awsConf: {
    Auth: {
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: 'us-gov-west-1:d3d0794f-4f09-453d-8f1d-79169559d37d',

      // REQUIRED - Amazon Cognito Region
      region: region,

      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: 'us-gov-west-1_Da4QRy6tf',

      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolWebClientId: '7a79130l3v9ku78stnja2omnf7',
    },
    Storage: {
      bucket: `${state}-${city}-${agencytype}-${envName}-ewarrant-uploads`,
      region: region,
    },
    API: {
      endpoints: [
        {
          name: 'cwApi',
          endpoint: apiUrl,
          region: region,
        },
      ],
    },
  },
  // can be ERROR | WARN | INFO | DEBUG | VERBOSE
  awsLogLevel: 'DEBUG',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error'; // Included with Angular CLI.
